module.exports = __webpack_public_path__ + "static/media/Hamburger.177219c2.svg";